import { makeRequest } from '../utils/apiUtils';

export const GET_WEBMASTER_TYPES = 'webmasterTypes/GET_WEBMASTER_TYPES';
export const GET_WEBMASTER_TYPES_SUCCESS = 'webmasterTypes/GET_WEBMASTER_TYPES_SUCCESS';
export const GET_WEBMASTER_TYPES_FAIL = 'webmasterTypes/GET_WEBMASTER_TYPES_FAIL';

export function getWebmasterTypes() {
  return makeRequest(`/saduka/webmasterTypes`, {
    types: [GET_WEBMASTER_TYPES, GET_WEBMASTER_TYPES_SUCCESS, GET_WEBMASTER_TYPES_FAIL],
    options: {
      credentials: 'include'
    },
  });
}
